import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAuth } from './RequireAuth';
import { AppShell } from './AppShell';
import { LoginPage } from '@/features/auth/LoginPage';
import { RegisterPage } from '@/features/auth/RegisterPage';
import { DashboardPage } from '@/features/DashboardPage';
import { CustomersPage } from '@/features/customers/CustomersPage';
import { ObjectsPage } from '@/features/objects/ObjectsPage';
import { ProjectsPage } from '@/features/projects/ProjectsPage';
import { CapturePage } from '@/features/capture/CapturePage';
import { ApprovalPage } from '@/features/approvals/ApprovalPage';
import { FieldReportsPage } from '@/features/field-reports/FieldReportsPage';
import { ExtraServicesPage } from '@/features/extra-services/ExtraServicesPage';
import { ReportsPage } from '@/features/reports/ReportsPage';

export const router = createBrowserRouter([
  { path: '/anmelden', element: <LoginPage /> },
  { path: '/erfassen/:token', element: <CapturePage /> },
  { path: '/freigabe/:token', element: <ApprovalPage /> },
  { path: '/registrieren', element: <RegisterPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'kunden', element: <CustomersPage /> },
      { path: 'objekte', element: <ObjectsPage /> },
      { path: 'auftraege', element: <ProjectsPage /> },
      { path: 'meldungen', element: <FieldReportsPage /> },
      { path: 'zusatzleistungen', element: <ExtraServicesPage /> },
      { path: 'berichte', element: <ReportsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
